export default __webpack_public_path__ + "static/media/barcode-exam.8e157197.png";